package one.healthium.today.di

import one.healthium.log_symptoms.di.logSymptomsUiModule
import org.koin.dsl.module

val todayUiCarniModule = module {
    includes(todayModule, logSymptomsUiModule)
}